export enum ProjectTable {
  WorkList = 1,
  DraftFindings = 2,
  ManagerReview = 3,
  RoundTableReview = 4,
  RoundTable = 5,
  Escalated = 6,
  Finalised = 7,
  RoundTableFinding = 8,
  ClaimKudos = 9,
  DetailedReporting = 10,
}
